import { useQuery } from '@tanstack/react-query'
import { QueryKey } from 'src/reactQuery/enums/queryKey.enum'
import { ReviewAnalysisApiService } from 'src/services/reviewAnalysisApi'

interface UseGetReviewAnalysisSmartInsightsQueryParams {
  campaignId: string
  facilityId?: string
  from?: string
  platformId?: string
  to?: string
}

export const useGetReviewAnalysisSmartInsightsQuery = ({
  campaignId,
  facilityId,
  from,
  platformId,
  to,
}: UseGetReviewAnalysisSmartInsightsQueryParams) =>
  useQuery({
    enabled: !!campaignId,
    queryFn: () =>
      ReviewAnalysisApiService.getSmartInsights(campaignId, {
        facilityId,
        from,
        platformId,
        to,
      }),
    queryKey: [
      QueryKey.GET_REVIEW_ANALYSIS_SMART_INSIGHTS,
      campaignId,
      facilityId ?? '',
      platformId ?? '',
      from ?? '',
      to ?? '',
    ],
  })
